<template>
    <div class="agreement-box">
        <iframe src="https://www.09game.com/html/about/agreement/index.html" 
            id="iframeContainer" frameborder="0" scrolling="auto" ></iframe>
    </div>
</template>
<script>
export default {
    name: 'user_agreement',
    data() {
        return {
            
        }
    },
    mounted() {
        this.initIframe()
    
        window.onresize = () => {
            this.initIframe()
        }
    },
    methods: {
        initIframe() {
            const iframeContainer = document.getElementById('iframeContainer')
            const deviceWidth = document.body.clientWidth
            const deviceHeight = document.body.clientHeight
            iframeContainer.style.width =  Number(deviceWidth) + 'px'
            iframeContainer.style.height = Number(deviceHeight) + 'px'
        }
    }
}
</script>
<style lang="scss" scoped>
    .agreement-box{
        width: 100%;
        height: 100%;
    }
</style>




// WEBPACK FOOTER //
// src/view/user_agreement.vue